export default {
  namespaced: true,
  plane: {
    title: "Plano",
    add: "Agregar",
    name: "Nombre",
    instructions: "Instrucciones",
    devices: "Dispositivos",
    maintenance: "Mantenimiento",
    maintenance_partial: "En mantenimiento parcial",
    maintenance_total: "En mantenimiento total",
    image: "Arrastra una imagen",
    add_device: "Al texto o dispositivo para agregar al plano",
    move_plane: "Mantenga presionado para mover el plano",
    rotate_device: "Mantenga presionado para rotar el dispositivo",
    no_floor_plant: "No has configurado ningún plano para esta instalación",
    no_floor_plant_permission: "No tienes permiso para ver los planos de esta instalación",
    floor_plant_load_error: "No fue posible cargar los planos de esta instalación",
    floor_plant_context_missing: "No se pudo identificar la instalación de esta alarma",
    button_text: "Haga clic aquí para configurar un plano para esta instalación",
  },
}
